import Invoice from "./invoice/invoice";

const ConferenceInvoice = () => {
  return <Invoice eventType="Conference" />;
};

export default ConferenceInvoice;
